import { render, staticRenderFns } from "./DashboardSetting.vue?vue&type=template&id=372aa568"
import script from "./DashboardSetting.vue?vue&type=script&lang=js"
export * from "./DashboardSetting.vue?vue&type=script&lang=js"
import style0 from "./DashboardSetting.vue?vue&type=style&index=0&id=372aa568&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports